// Identifies the user, or resets after a logout. Returns the id now identified.
export const syncAmplitudeIdentity = (amplitude, identifiedUserId, user) => {
    if (user) {
        const { id, ...userProperties } = user;
        amplitude.identify(id, userProperties);
        return id;
    }
    if (identifiedUserId)
        amplitude.reset();
    return null;
};
//# sourceMappingURL=amplitude-identity.js.map